import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _createClass from "babel-runtime/helpers/createClass";

/**
 * Not implemented yet.
 */
var BrowserSignalListener = function () {
  function BrowserSignalListener() {
    // noop

    _classCallCheck(this, BrowserSignalListener);
  }

  _createClass(BrowserSignalListener, [{
    key: "start",
    value: function start() {
      // noop
    }
  }, {
    key: "stop",
    value: function stop() {
      // noop
    }
  }]);

  return BrowserSignalListener;
}();

export default BrowserSignalListener;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/listeners/browser.js
// module id = 2211
// module chunks = 0